import React, { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import { featureFlags } from '@config/featureFlags';

// Lazy: the outlet pulls in the sheet bodies (vaul, the Post sheet), which nothing needs while the
// flag is off, so the entry chunk stays as it was before the sheet existed (TECH-197 FE-4).
const PostSheetOutlet = lazy(() =>
  import('./PostSheetOutlet').then(m => ({ default: m.PostSheetOutlet })),
);

/**
 * RootLayout's outlet. Flag off: the plain `<Outlet />`, exactly as before the Post sheet, so the
 * route tree, its default error boundary (react-router puts it on the root match) and the entry
 * chunk are unchanged. Flag on: `PostSheetOutlet`, always, sheet or not, because swapping element
 * trees when a sheet opens would remount the feed behind it. The flag is a build-time constant, so
 * the two never alternate in the app.
 *
 * AIDEV-NOTE: with the flag on, a route render error is caught by the first table route's default
 * boundary (inside RootLayout's providers) rather than the root's; same default UI.
 */
export const RootOutlet: React.FC = () =>
  featureFlags.postSheet ? <PostSheetOutlet /> : <Outlet />;
